module.exports = __webpack_public_path__ + "img/img01.5a9f5624.jpeg";